"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Button = _interopRequireDefault(require("../Button"));
var _SingleClickSelection = _interopRequireDefault(require("./SingleClickSelection.proptypes"));
var _constant = require("./constant");
var _constant2 = require("../JourneyPriceCTA/constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Container = _styledComponents.default.div.withConfig({
  displayName: "SingleClickSelection__Container",
  componentId: "sc-4y0yfk-0"
})(["display:flex;flex-direction:", ";align-items:center;"], function (_ref) {
  var vertical = _ref.vertical;
  return vertical ? 'column' : 'row';
});
var SingleClickSelection = function SingleClickSelection(props) {
  var accessible = props.accessible,
    color = props.color,
    theme = props.theme,
    customProperties = props.customProperties,
    customButtonWidth = props.customButtonWidth,
    data = props.data,
    hoverColor = props.hoverColor,
    hoverBackgroundColor = props.hoverBackgroundColor,
    onClick = props.onClick,
    vertical = props.vertical,
    selectedButtonBorderColor = props.selectedButtonBorderColor,
    selectButtonBackgroundColor = props.selectButtonBackgroundColor,
    value = props.value;
  var options = data;
  var selectedItem = options.findIndex(function (obj) {
    return obj.value === value;
  });
  var _useState = (0, _react.useState)(selectedItem),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isSelected = _useState2[0],
    setIsSelected = _useState2[1];

  // Effect to update isSelected when value changes
  (0, _react.useEffect)(function () {
    setIsSelected(selectedItem);
  }, [value, selectedItem]);
  var _handleClick = function handleClick(index) {
    if (index === isSelected) {
      setIsSelected(-1);
    } else {
      setIsSelected(index);
    }
    onClick(options[index].value); // Call onClick with the selected value
  };

  var getColor = function getColor() {
    var move = theme === _constant2.THEMES.MOVE;
    return move ? 'secondary' : selectedButtonBorderColor;
  };
  var getMain = function getMain() {
    return options && options.length && /*#__PURE__*/_react.default.createElement(Container, {
      vertical: vertical
    }, options.map(function (element, index) {
      return /*#__PURE__*/_react.default.createElement(_Button.default, {
        key: element.value,
        theme: theme,
        accessible: accessible,
        width: customButtonWidth,
        customProperties: customProperties,
        color: color,
        backgroundColor: index === isSelected ? selectButtonBackgroundColor : _constant.DEFAULT_COLOR.BACKGROUND_COLOR,
        border: index === isSelected ? getColor() : _constant.DEFAULT_COLOR.BORDDER_COLOR,
        borderRadius:
        // eslint-disable-next-line no-nested-ternary
        index === 0 ? _constant.BORDER_RADIUS.LEFT : index === options.length - 1 ? _constant.BORDER_RADIUS.MIDDLE : _constant.BORDER_RADIUS.RIGHT,
        hoverColor: hoverColor,
        hoverBackgroundColor: hoverBackgroundColor,
        handleClick: function handleClick() {
          return _handleClick(index);
        }
      }, element.label);
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
SingleClickSelection.propTypes = _SingleClickSelection.default.PropTypes;
SingleClickSelection.defaultProps = _SingleClickSelection.default.DefaultProps;
var _default = SingleClickSelection;
exports.default = _default;